import { useMediaQuery } from 'react-responsive';
import TermsOfService from './TermsOfService';
import MobileTerms from './MobileTerms';

const TermsRouter = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 }); // adjust breakpoint if needed

  return isMobile ? <MobileTerms /> : <TermsOfService />;
};

export default TermsRouter;
